import Free from '../component/Free'
import Currency from '../component/Currency'
import VIP from '../component/VIP'
import { useMemo } from 'react'

const paymentTypeImage: Record<number, React.ComponentType<any>> = {
  1: Free,
  2: Currency,
  3: VIP,
}

/**
 *
 * @param videoInfo
 * @returns
 */
export const usePaymentTypeImage = (videoInfo: any) => {
  const Tag = paymentTypeImage[videoInfo.payment_type as number] ?? Free

  return useMemo(() => <Tag {...videoInfo} />, [videoInfo])
}
